
$( document ).ready(function() {

  if ($("#editPage").length){


  }

});



// WEBPACK FOOTER //
// ./resources/assets/js/admin/pages/page.js